/**
 * This is an helper class to help handle concurrent requests. As of now, the
 * only cases are list request with query parameters. Almost every time, the network
 * timing will be right, but since the yupValidation is also async it is easy to trigger
 * requests in order 1 -> 2 -> 3 and receive 1 -> 3 -> 2.
 *
 * So this helper class will only make sure only the last request can be shown
 *
 * One tag per store instance: a second method sharing it can silently drop
 * the other's in-flight response (no error, no spinner). Guard independent
 * fetches with per-key tags instead (see AcvtStore.getTag in acvt.ts).
 */
export abstract class WithNetworkConcurrency {
    private latestTag = Symbol();

    protected getTag() {
        this.latestTag = Symbol();
        return this.latestTag;
    }

    protected isLatestTag(tag: symbol) {
        return this.latestTag === tag;
    }
}
